import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import HorizontalSlider from "../common/components/HorizontalSlider";
import { lifeWillBe } from "../features/listenerProfile";
import VerticalCenter from "../common/components/VerticalCenter";
import Center from "../common/components/Center";
import Padding from "../common/components/Padding";

export default function Question3LifeWillBe() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <>
      <Padding>
        <Center>
          <h1>
            {t(
              "What will your life be like in 5 years if you continue as you are today?"
            )}
          </h1>
        </Center>
      </Padding>
      <VerticalCenter>
        <HorizontalSlider
          leftElement={<p>{t("Better")}</p>}
          values={[1, 2.33, 3.66, 5]}
          defaultValue={2.33}
          onChange={(value) => dispatch(lifeWillBe(value))}
          rightElement={<p>{t("Worse")}</p>}
        />
      </VerticalCenter>
    </>
  );
}
